import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface InvestmentMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allInvestmentMaster: [] | null | any;
}
const initialState: InvestmentMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allInvestmentMaster: null,
};
export const investmentMasterSlice = createSlice({
  name: 'InvestmentMaster',
  initialState,
  reducers: {
    setAllInvestmentMaster: (state, action) => {
      state.allInvestmentMaster = action.payload.data;
    },
    setInvestmentMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllInvestmentMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setAllInvestmentMaster, setInvestmentMaster, setAllInvestmentMasterBySearch,reset } = investmentMasterSlice.actions;
export const allInvestmentMasterDetails = (state: RootState) => state.investmentMaster.allInvestmentMaster;
export const getAllInvestmentMasterDetails = (state: RootState) => state.investmentMaster.data;
export const getInvestmentMasterTotalRecords=(state:RootState)=>state.investmentMaster.totalRecords;
export const getAllInvestmentMasterBySearch = (state: RootState) => state.investmentMaster.data;
export default investmentMasterSlice.reducer;